import { SearchEventsRefinementsLoadable } from '#/modules/search/pages/Events/components/SearchEventsRefinementsLoadable';
import { SearchInternshipRefinementsLoadable } from '#/modules/search/pages/Internships/components/SearchInternshipRefinementsLoadable';
import { SearchJobsRefinementsLoadable } from '#/modules/search/pages/Jobs/components/SearchJobsRefinementsLoadable';
import { SearchOrgRefinementsLoadable } from '#/modules/search/pages/Orgs/components/SearchOrgRefinementsLoadable';
import { SearchVolopsRefinementsLoadable } from '#/modules/search/pages/Volops/components/SearchVolopsRefinementsLoadable';
import type { ListingType } from '#/types/ListingType';

type Args = {
  searchType: ListingType;
};

export function SearchRefinementsSwitch({ searchType }: Args) {
  switch (searchType) {
    case 'JOB':
      return <SearchJobsRefinementsLoadable />;
    case 'INTERNSHIP':
      return <SearchInternshipRefinementsLoadable />;
    case 'VOLOP':
      return <SearchVolopsRefinementsLoadable includeSourcesFacet={false} />;
    case 'ORG':
      return <SearchOrgRefinementsLoadable />;
    case 'EVENT':
      return <SearchEventsRefinementsLoadable />;
  }
}
